import { InsightsViewModel } from "./../models/preplabModels";
import { useFetchApiData } from "./useFetchApiData";

export const useGetInsights = () => {
    return useFetchApiData<InsightsViewModel>("/api/Insights/GetPackagesData");
};
